import { fromJS } from 'immutable';

import { HIDE_ALERT, HIDE_DIALOG, SHOW_ALERT, SHOW_DIALOG } from '../constants/dialogs';

const initialState = fromJS({
  dialogs: {
  },
});

function appReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_ALERT:
      return state.setIn(['alert'], fromJS({ visible: true, config: action.config }));
    case HIDE_ALERT:
      return state.setIn(['alert'], fromJS({ visible: false }));
    case SHOW_DIALOG:
      return state.setIn([action.name], fromJS({ visible: true, context: action.context }));
    case HIDE_DIALOG:
      return state.setIn([action.name], fromJS({ visible: false}));
    default:
      return state;
  }
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/dialogs.js